enum DealIDType {
  Regular = 'regular',
  Curated = 'curated',
  PackageGroup = 'package-group',
  External = 'external',
  VideoDisplay = 'video-display',
}

export default DealIDType;
